<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title">
          <a-icon type="file-search" />&nbsp;Search
        </div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" :disabled="triggerSearch" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker
                    placeholder="Select Date"
                    v-model="searchDate"
                    :disabled="triggerSearch"
                    format="DD-MMM-YYYY"
                    allowClear
                  />
                </div>

                <div class="m-form-item-wrapper" >
                  <label for="director">Director</label>
                  <a-select
                    placeholder="Choose director"
                    v-model="director"
                    :disabled="triggerSearch"
                    class="width-full"
                    initialValue="undefined"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in listDirector"
                      :key="item.value"
                      :value="item.value"
                      >{{ item.text }}</a-select-option
                    >
                  </a-select>
                </div>

                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    :disabled="triggerSearch"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getStatus"
                      :key="item.id"
                      :value="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
         :tabbed="true"
         :loading="loading"
         title="Director Claim List"
         createLink="klaim-direktur-create"
         manifestLink="manifestDirectur"
         editLink="klaim-direktur-edit"
         draftEditLink="klaim-direktur-edit"
         :dataList="searching"
         :draftList="draft"
         :price="true"
         :allowcancel="true"
      />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";

export default {
  name: "klaim-directur-list",
  data() {
    return {
      draft: [],
      list: [],
      listDirector: [],
      search: "",
      loading: false,
      searchDate: null,
      status: undefined,
      director: undefined,
      triggerSearch: false,
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getScreen","getDefaultDateFormat","getStatus",]),
    searching() {
      let self = this;
      let output = this.list;
      if (this.search) {
        output = output.filter(
                (obj) =>
                        obj.title.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
                        obj.price.indexOf(this.search) >= 0
        );
      }

      if (this.searchDate) {
        let filter = moment(this.searchDate).format("YYYY-MM-DD");
        output = output.filter((obj) => obj.tgl_buat === filter);
      }

      if (this.director) {
        output = output.filter(
                (obj) =>
                        obj.subdesc.director && obj.subdesc.director.toLowerCase().indexOf(self.director.toLowerCase()) >= 0
        );
      }

      if (this.status) {
        output = output.filter(
                (obj) =>
                        obj.status && obj.status.toLowerCase().indexOf(self.status) >= 0
        );
      }

      return output;
    },
  },
  created() {
    this.fetch();
  },
  mounted(){
    Event.$on("callbackTab", this.clickTabed);
    Event.$on("handleCancel", this.canceltrans);
  },
  beforeDestroy() {
    Event.$off("callbackTab", this.clickTabed);
    Event.$off("handleCancel", this.canceltrans);
  },
  methods: {
    moment,
    fetch() {
      this.$store
        .dispatch("getList", {
          params: {
            auth: this.getAuth,
          },
        })
        .then((res) => {
          //console.log(res)

          this.list = res.list.data;
          this.draft = res.draft.data;

          this.listDirector = res.list.director;

          if (this.list !== undefined) {
            this.list = [];
            res.list.data.forEach((data) => {
              this.list.push({
                title: data.no_klaim_direktur,
                subdesc: {
                  director: data.director,
                  tanggal: moment(data.tgl_buat).format(
                          this.getDefaultDateFormat
                  ),
                },
                tgl_buat: data.tgl_buat,
                status: data.status,
                id: data.id_klaim_direktur,
                price: data.grand_total,
                cancelStatus: data.cancel_sts
                        ? data.cancel_sts == 1
                                ? "Canceled"
                                : null
                        : null,
                tlc_bod: data.tlc_bod
              });
            });
          }else {
            this.list = [];
          }

          if (this.draft !== undefined ) {
            this.draft = [];
            res.draft.data.forEach((data) => {
              this.draft.push({
                title: data.no_klaim_direktur,
                subdesc: {
                  tanggal: moment(data.tgl_buat).format(
                          this.getDefaultDateFormat
                  ),
                },
                tgl_buat: data.tgl_buat,
                status: data.status,
                id: data.id_klaim_direktur_draft,
                price: data.grand_total,
                cancelStatus: data.cancel_sts
                        ? data.cancel_sts == 1
                                ? "Canceled"
                                : null
                        : null,
              });
            });
          }else {
            this.draft = [];
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    clickTabed(val){
      this.search = "";
      this.searchDate = undefined;
      this.director = undefined;
      this.status = undefined;
      if (val=="draft"){
        this.triggerSearch = true;
      }else{
        this.triggerSearch = false;
      }
    },
    canceltrans(item) {
      axios({
        method: "post",
        url: this.$serviceUrl + "main/cancel_transaction",
        params: {
          tlc: this.getAuth.username,
        },
        data: {
          tlc: this.getAuth.username,
          jenis_trans: "klaim_cc",
          id_manifest: item.id,
          code_trans: item.title,
          kode_project: item.kode_project,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessageValue("successCancel", response.data.message);
          this.$router.go(0);
          //this.fetchData();
          //this.searching;
        })
        .catch((err) => {
          console.log(err);
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
  },
};
</script>

<style>
</style>